/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.divideElements = (function() {
    var txt = expocadfx.txt;
    var util = expocadfx.util;
	
	var doc = document;
    
    //  step, min, and max only applies to type=number, max only to inches 
    function dimInput( id, type, step) {
        //  ?? value and max ??
		var input = doc.createElement( "input");
		input.className = "divide_dim_input";
        input.setAttribute( "id", id);
        input.setAttribute( "type", type);
        if( type === "number") {
            input.setAttribute( "step", step);
            input.setAttribute( "min", "0");
            input.setAttribute( "max", "11");
        }
        if( type !== "number") {
            input.setAttribute( "readonly", true);
            util.addClass( input, "unselectable");
        }
		return input;
	}
    
    function dirRadio( id, value) {
        var input = doc.createElement( "input");
        input.setAttribute( "id", id);
        input.setAttribute( "type", "radio");
        input.setAttribute( "name", "direction");
        input.value = value;
        
        return input;
    }
    
    function makeSideLabel( side, isFeet) {
        var div = doc.createElement( "div");
        var label = doc.createElement( "label");
        var input = doc.createElement( "input");
        var step = isFeet ? 1 : 0.25;
        var type = "input";
        
        div.setAttribute( "id", side + "Side");
        div.className = "divide_label";
        label.textContent = txt.NUMBER;
        div.appendChild( label);
        input.setAttribute( "type", "text");
        input.setAttribute( "id", side + "Number");
        input.setAttribute( "placeholder", "New Number");
        div.appendChild( input);
        
        
        if( isFeet) {
            input = dimInput( side + "Ft", "input", step);
            div.appendChild( input);
            label = doc.createElement( "label");
            label.textContent = isFeet ? "ft" : "m";
            div.appendChild( label);
            
            if( side === "a") {
                type = "number";
            }
            input = dimInput( side + "In", type, step);
            div.appendChild( input);
            label = doc.createElement( "label");
            label.textContent = "in";
            div.appendChild( label);
        }
        else {
            type = "input";  //   (side === "a") ? "number" : "input";
            input = dimInput( side + "Ft", type, step);
            div.appendChild( input);
            label = doc.createElement( "label");
            label.textContent = isFeet ? "ft" : "m";
            div.appendChild( label);
        }
        
        return div;
    }

	return {
		dimInput: dimInput,
        dirRadio: dirRadio,
        makeSideLabel: makeSideLabel
	};
}());